import { Stack, Container, Typography } from '@mui/material';
import TopupDepositTableView from 'src/sections/management/user/tabs/topup-deposit/topup-view';

export default function TopupDepositView() {
  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4" gutterBottom>
          วงเงินหลักประกัน
        </Typography>
        <TopupDepositTableView enableCreate isCreateAndApprove />
      </Stack>
    </Container>
  );
}
